import React, { createContext, type ReactNode } from 'react';
import { TourSpotlighTargetName } from './TourSpotlightTarget';

interface TourSpotlightContextValue {
	activeTarget: TourSpotlighTargetName | null;
	content: ReactNode | null;
}

export const TourSpotlightContext = createContext<TourSpotlightContextValue | null>(null);

export const TourSpotlightProvider = ({
	children,
	activeTarget,
	content,
}: {
	children: ReactNode;
	activeTarget: TourSpotlighTargetName | null;
	content: ReactNode | null;
}): React.JSX.Element => {
	return (
		<TourSpotlightContext.Provider value={{ activeTarget, content }}>
			{children}
		</TourSpotlightContext.Provider>
	);
};
